import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-new-staff',
  templateUrl: './helpbutton-new-staff.component.html',
  styleUrls: ['./helpbutton-new-staff.component.scss']
})
export class HelpbuttonNewStaffComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
